import React, { useState } from 'react';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import Navbar from './NavbarStory';
import Calling from '../../api/Calling';
import { useEffect } from 'react';
import formatDateTime from '../../components/formatDateTime';
import genrateCaptch from '../../components/captcha';
import { useNavigate } from 'react-router-dom';
import { MdDeleteSweep } from "react-icons/md";
import { FaEdit, FaTrash } from "react-icons/fa";
import { FaRegCirclePlay } from "react-icons/fa6";
import { formatView } from '../../components/formatView';
import { imageType, videoType, MAX_FILE_SIZE_IMAGE, videoSizeExceededMessage, invalidVideoMessage, MAX_FILE_SIZE_VIDEO, invalidImageMessage, imageSizeExceededMessage } from '../../components/imageType'; // Import the allowed image types
import UploadButton from '../../components/ul/UploadButton';
import FileUpload from '../../components/ul/FileUpload';
import ActionButton from '../../components/ul/ActionButton';
import { LuDot } from 'react-icons/lu';
import ResetButton from '../../components/ul/ResetButton';
import NotFound from '../../components/ul/NotFound';
import ClickView from '../../components/ul/ClickView';
const StoryVideo = () => {
    const [loader, setLoader] = useState(false);
    const [story, setStory] = useState({
        name: '',
        storyList: 'Image',
        storyTime: 10,
        view: '',
        btnName: "",
        btnUrl: ""
    });
    const navigate = useNavigate();
    const [imageFile, setImageFile] = useState(null);
    const [videoFile, setVideoFile] = useState(null);
    const [stories, setStories] = useState([]);
    const [file, setFile] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [firstStoryVideo, setFirstStoryVideo] = useState(true);
    const [maxView, setMaxView] = useState(0)
    const [maxClick, setMaxClick] = useState(0);
    const [selectedLimit, setSelectedLimit] = useState("None");
    const [limitList, setLimitList] = useState([
        "None",
        "View",
        "Click"
    ])
    const [fileProcessing, setFileProcessing] = useState({
        image: false,
        video: false,
    });
    const [fileStatus, setFileStatus] = useState({
        image: null, // 'success', 'error', or null
        video: null,
    });

    const fetchStories = async () => {
        setLoader(true);
        try {
            const response = await Calling.getStories(1, 200);
            if (response?.status) {
                setStories(response?.data || []);
                setFirstStoryVideo(response?.firstStoryVideo);
            } else {
                toast.error(response?.message)
            }
        } catch (error) {
            console.error(error);
            navigate('/Error');
        } finally {
            setLoader(false);
        }
    };
    useEffect(() => {
        fetchStories()
    }, [])

    const handleEdit = (id) => {
        navigate(`/update/story/video/${id}`)
    };

    const handleChangeStory = (e) => {
        setStory({ ...story, [e.target.name]: e.target.value });
    };

    const handleChangeFile = (e) => {
        const { name, files, id } = e.target;
        const file = files[0];

        if (file) {
            if (name === 'image') {
                if (!imageType.includes(file.type)) {
                    setFile(null);
                    toast.error(invalidImageMessage);
                    setImageFile(null);
                    setFileProcessing(prevState => ({ ...prevState, [name]: false }));
                    setFileStatus(prevState => ({ ...prevState, [name]: 'error' }));

                    e.target.value = '';
                    return;
                }
                if (file.size > MAX_FILE_SIZE_IMAGE) {
                    setFile(null);
                    toast.error(imageSizeExceededMessage);
                    setImageFile(null);
                    setFileProcessing(prevState => ({ ...prevState, [name]: false }));
                    setFileStatus(prevState => ({ ...prevState, [name]: 'error' }));
                    e.target.value = '';
                    return;
                }
            }

            if (name === 'video') {
                if (!videoType.includes(file.type)) {
                    setFile(null);
                    toast.error(invalidVideoMessage);
                    setVideoFile(null);
                    setFileProcessing(prevState => ({ ...prevState, [name]: false }));
                    setFileStatus(prevState => ({ ...prevState, [name]: 'error' }));
                    e.target.value = '';
                    return;
                }
                if (file.size > MAX_FILE_SIZE_VIDEO) {
                    setFile(null);
                    toast.error(videoSizeExceededMessage);
                    setVideoFile(null);
                    setFileProcessing(prevState => ({ ...prevState, [name]: false }));
                    setFileStatus(prevState => ({ ...prevState, [name]: 'error' }));
                    e.target.value = '';
                    return;
                }


            }

            setFileProcessing(prevState => ({ ...prevState, [id]: true }));
            setFileStatus(prevState => ({ ...prevState, [id]: null }));

            // Simulate file processing
            setTimeout(() => {
                setFileProcessing(prevState => ({ ...prevState, [id]: false }));
                setFileStatus(prevState => ({ ...prevState, [id]: 'success' }));
            }, 1000); // Simulate a delay

            // Update file states

            if (name === 'image') {
                setFile(true);
                setImageFile(file);
            } else if (name === 'video') {
                setFile(true);
                setVideoFile(file);
            }
        }
    };

    const handleLimitChange = (e) => {
        const value = e.target.value;
        setSelectedLimit(value);

        // Reset values when changing selection
        if (value === "None") {
            setMaxView(0);
            setMaxClick(0);
        }
    };

    const handleDeleteStory = async (id) => {
        setLoader(true);
        try {
            const content = `You are about to delete Story. To confirm, please solve this math problem`
            const check = genrateCaptch(content);
            if (check) {
                let body = {}
                if (!id) {
                    body.id = selectedUsers

                } else {
                    body.id = [id];
                }

                const response = await Calling.deleteStoryVideo(body);
                const { status, message } = response;
                if (status) {
                    setTimeout(() => {
                        toast.success(message, { autoClose: 2000 });
                    }, 5);
                    fetchStories();
                    setSelectedUsers([]);
                } else {
                    setTimeout(() => {
                        toast.error(message, { autoClose: 2000 });
                    }, 1);
                }
            } else {
                toast.error("Ans in not currect", { autoClose: 2000 });
            }
        } catch (error) {
            console.log(error);
            navigate('/Error');
        } finally {
            setLoader(false);
        }
    };


    const handleSubmitData = async (e) => {
        e.preventDefault();

        // Validate required files
        if (!file) {
            toast.error("Please select a valid image to upload.");
            return;
        }

        try {
            setLoader(true);
            const data = new FormData();

            // Add media files based on story type
            const isVideo = story?.storyList === 'Video';
            data.append(isVideo ? 'video' : 'image', isVideo ? videoFile || '' : imageFile || '');
            data.append(isVideo ? 'image' : 'video', '');
            data.append(isVideo ? 'image' : 'video', '');

            // Prepare base story data
            const storyData = {
                storyTime: story?.storyTime,
                adsStory: false,
                btnName: story?.btnName || '',
                btnUrl: story?.btnUrl || ''
            };

            // Add limit settings if applicable
            if (selectedLimit === "View") {
                storyData.maxviewLimit = maxView;
                storyData.maxviewStatus = true;
            } else if (selectedLimit === "Click") {
                storyData.maxclickLimit = maxClick;
                storyData.maxclickStatus = true;
            }

            // Append final JSON data
            data.append('insertData', JSON.stringify(storyData));

            // Submit data
            const resp = await Calling.addStoryVideo(data);

            // Handle response
            if (resp.status) {
                toast.success(resp.message, { autoClose: 2000 });
            } else {
                toast.error(resp.message, { autoClose: 2000 });
            }
        } catch (error) {
            console.error("Error submitting story:", error);
            toast.error("An error occurred while submitting the story.");
            // Only navigate to error page for severe errors if needed
            // navigate('/Error');
        } finally {
            // Reset all form state
            handleReset();
            fetchStories(); // Refresh the stories list
        }
    };

    const handleselect = async (userId) => {
        setSelectedUsers((prev) => prev.includes(userId) ? prev.filter(id => id !== userId) : [...prev, userId]);
    }
    const handleViewAnalitic = (id) => {
        navigate(`/views/dashboard/${id}`)
    }

    const handleReset = () => {
        setVideoFile(null);
        setImageFile(null);
        setStory({
            storyList: 'Image',
            storyTime: 10,
        });
        setMaxView(0);
        setMaxClick(0);
        setSelectedLimit("None")
        setFileProcessing({ image: false, video: false });
        setFileStatus({ image: null, video: null });
    }


    const handleCheckboxChange = async (userId, status) => {
        try {
            // Call API to update story ads status
            const resp = await Calling.changeStoryVideoStatus(userId, status);
            const { status: responseStatus, message } = resp;

            if (responseStatus) {
                // Show success message

                setTimeout(() => { toast.success(message); }, 1)
                await fetchStories();
            } else {
                // Show error message if API returns failure
                toast.error(message);
            }
        } catch (error) {
            // Handle errors like network failure
            navigate('/Error');
            toast.error('Failed to update story video');
        }
    };
    return (
        <>
            {loader ? (
                <Loader loader={loader} />
            ) : (
                <div className='w-full text-main-font mt-16 px-2 sm:px-3 md:ml-[4.4rem]'>
                    <h1 className="text-xl md:text-2xl font-bold mt-4 text-main-font w-auto">Story Management</h1>
                    <div className='bg-main-white rounded-xl shadow-sm mt-3'>
                        <Navbar selectState={'video'} />
                        <hr className='mt-2 bg-main-border border-[1px]' />


                        <div className='p-3 sm:p-4 md:p-6'>
                            <div className='flex flex-col sm:flex-row justify-between items-start sm:items-center mb-3 md:mb-5 gap-2'>
                                <h1 className='text-lg md:text-2xl font-bold text-main-font'>Add Story Video</h1>
                                {firstStoryVideo ? (
                                    <span className='px-3 py-1 text-xs md:text-sm rounded-full bg-green-100 text-green-600 flex items-center whitespace-nowrap'>
                                        <LuDot size={16} className="md:text-xl" /> Running
                                    </span>
                                ) : (
                                    <span className='px-3 py-1 text-xs md:text-sm rounded-full bg-red-100 text-red-600 flex items-center whitespace-nowrap'>
                                        <LuDot size={16} className="md:text-xl" /> Not Running
                                    </span>
                                )}
                            </div>
                            <hr className='border-main-border' />


                            <form className='space-y-6 mt-6' encType='multipart/form-data' onSubmit={handleSubmitData}>
                                {/* Video Type and Timing Section */}
                                <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                                    {/* Video Type Field */}
                                    <div>
                                        <label htmlFor='storyList' className='block text-sm font-medium text-main-font mb-1'>
                                            Type
                                        </label>
                                        <select
                                            id='storyList'
                                            name='storyList'
                                            value={story?.storyList}
                                            onChange={handleChangeStory}
                                            className='w-full p-2.5 border border-main-border rounded-md focus:ring-2 focus:ring-main-subfont focus:outline-none focus:border-transparent'
                                            required
                                        >
                                            <option value='Video'>Video</option>
                                            <option value='Image'>Image</option>
                                        </select>
                                    </div>

                                    {/* Timing Field */}
                                    <div>
                                        <label htmlFor='storyTime' className='block text-sm font-medium text-main-font mb-1'>
                                            Timing
                                        </label>
                                        <input
                                            type='number'
                                            value={story?.storyTime}
                                            id="storyTime"
                                            name='storyTime'
                                            onChange={handleChangeStory}
                                            className='w-full p-2.5 border border-main-border rounded-md focus:ring-2 focus:ring-main-subfont focus:outline-none focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed'
                                            placeholder='Enter story timing'
                                            min={0}
                                            required
                                            disabled={story?.storyList === 'Video'}
                                        />
                                    </div>
                                </div>

                                {/* Button Name and URL Section */}
                                <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                                    {/* Button Name Field */}
                                    <div>
                                        <label htmlFor='btnName' className='block text-sm font-medium text-main-font mb-1'>
                                            Button Name
                                        </label>
                                        <input
                                            type='text'
                                            value={story?.btnName}
                                            id="btnName"
                                            name='btnName'
                                            onChange={handleChangeStory}
                                            className='w-full p-2.5 border border-main-border rounded-md focus:ring-2 focus:ring-main-subfont focus:outline-none focus:border-transparent'
                                            placeholder='Enter button name (e.g., Go Shop Now)'
                                        />
                                    </div>

                                    {/* Button URL Field */}
                                    <div>
                                        <label htmlFor='btnUrl' className='block text-sm font-medium text-main-font mb-1'>
                                            Button URL
                                        </label>
                                        <input
                                            type='url'
                                            value={story?.btnUrl}
                                            id="btnUrl"
                                            name='btnUrl'
                                            onChange={handleChangeStory}
                                            className='w-full p-2.5 border border-main-border rounded-md focus:ring-2 focus:ring-main-subfont focus:outline-none focus:border-transparent'
                                            placeholder='Enter button URL'
                                        />
                                    </div>
                                </div>

                                {/* Video or Image Upload Based on Type */}
                                {story?.storyList === 'Video' ? (
                                    <div>
                                        <label htmlFor='video' className='block text-sm font-medium text-main-font mb-1'>
                                            Video File
                                        </label>
                                        <div className='relative'>
                                            <FileUpload
                                                id="video"
                                                name='video'
                                                accept="video/mp4"
                                                onChange={handleChangeFile}
                                                required={true}
                                            />
                                            <div className='absolute top-2 right-2'>
                                                {fileProcessing['video'] && <div className='loader'></div>}
                                                {fileStatus['video'] === 'error' && <span className='text-red-500 text-xl'>✘</span>}
                                                {fileStatus['video'] === 'success' && <span className='text-green-500 text-xl'>✓</span>}
                                            </div>
                                            <p className={`text-xs mt-1 ${fileStatus['video'] === 'error' ? 'text-main-delete' : 'text-main-subfont'}`}>
                                                Only MP4 files are allowed
                                            </p>
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <label htmlFor='image' className='block text-sm font-medium text-main-font mb-1'>
                                            Image File
                                        </label>
                                        <div className='relative'>
                                            <FileUpload
                                                id="image"
                                                name='image'
                                                accept="image/png, image/jpeg, image/jpg"
                                                onChange={handleChangeFile}
                                                required={true}
                                            />
                                            <div className='absolute top-2 right-2'>
                                                {fileProcessing['image'] && <div className='loader'></div>}
                                                {fileStatus['image'] === 'error' && <span className='text-red-500 text-xl'>✘</span>}
                                                {fileStatus['image'] === 'success' && <span className='text-green-500 text-xl'>✓</span>}
                                            </div>
                                            <p className={`text-xs mt-1 ${fileStatus['image'] === 'error' ? 'text-main-delete' : 'text-main-subfont'}`}>
                                                Only PNG, JPG, JPEG files are allowed
                                            </p>
                                        </div>
                                    </div>
                                )}

                                {/* Limit Settings Section */}
                                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                                    <h3 className="text-lg font-medium text-gray-900 mb-4">Limit Settings</h3>

                                    <div className="space-y-4">
                                        <div>
                                            <label htmlFor="limit-type" className="block text-sm font-medium text-gray-700 mb-1">
                                                Limit Type
                                            </label>
                                            <select
                                                id="limit-type"
                                                value={selectedLimit}
                                                onChange={handleLimitChange}
                                                className="w-full p-2.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            >
                                                {limitList.map((limit) => (
                                                    <option key={limit} value={limit}>
                                                        {limit}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {selectedLimit === "View" && (
                                            <div>
                                                <label htmlFor="max-view" className="block text-sm font-medium text-gray-700 mb-1">
                                                    Maximum Views
                                                </label>
                                                <input
                                                    type="number"
                                                    id="max-view"
                                                    value={maxView}
                                                    onChange={(e) => setMaxView(parseInt(e.target.value) || 0)}
                                                    min="0"
                                                    className="w-full p-2.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                    placeholder="Enter maximum view count"
                                                />
                                            </div>
                                        )}

                                        {selectedLimit === "Click" && (
                                            <div>
                                                <label htmlFor="max-click" className="block text-sm font-medium text-gray-700 mb-1">
                                                    Maximum Clicks
                                                </label>
                                                <input
                                                    type="number"
                                                    id="max-click"
                                                    value={maxClick}
                                                    onChange={(e) => setMaxClick(parseInt(e.target.value) || 0)}
                                                    min="0"
                                                    className="w-full p-2.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                    placeholder="Enter maximum click count"
                                                />
                                            </div>
                                        )}

                                        {selectedLimit !== "None" && (
                                            <p className="text-sm text-gray-500 italic">
                                                {selectedLimit === "View"
                                                    ? "Product will be limited by the number of times it's viewed."
                                                    : "Product will be limited by the number of times it's clicked."}
                                            </p>
                                        )}
                                    </div>
                                </div>

                                {/* Form Buttons */}
                                <div className='flex flex-wrap gap-3 pt-4'>
                                    <UploadButton className='inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500' />
                                    <ResetButton className='inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500' onClick={handleReset} />
                                </div>
                            </form>

                        </div>

                        <hr className='border-main-border border-[2px] mt-2' />

                        {/* Story List Section */}
                        <div className='bg-main-white'>
                            {/* Header and Search */}
                            <div className='flex flex-col sm:flex-row justify-between items-start sm:items-center p-3 md:p-6 gap-3'>
                                <h1 className='font-bold text-main-font text-lg md:text-2xl'>Story Video List</h1>
                                {selectedUsers.length > 0 && (
                                    <button
                                        onClick={() => handleDeleteStory()}
                                        className="bg-main-delete text-white px-3 py-1.5 rounded text-sm flex items-center"
                                    >
                                        <MdDeleteSweep size={20} />
                                        <span className="ml-1">{selectedUsers.length}</span>
                                    </button>
                                )}
                            </div>

                            {/* Mobile Card View for Stories */}
                            <div className='sm:hidden p-3'>
                                {stories.length > 0 ? (
                                    <div className="space-y-4">
                                        {stories.map((story, i) => (
                                            <div key={story?._id} className="border rounded-lg p-3 shadow-sm">
                                                <div className="flex justify-between items-start mb-2">
                                                    <div className="flex items-center">
                                                        <input
                                                            type="checkbox"
                                                            className="cursor-pointer mr-2 h-4 w-4"
                                                            checked={selectedUsers.includes(story?._id)}
                                                            onChange={() => handleselect(story?._id)}
                                                        />
                                                        <div className="flex flex-col">
                                                            <div className="flex items-center">
                                                                <span className="bg-gray-200 text-xs rounded px-2 py-1 mr-2">#{i + 1}</span>
                                                            </div>
                                                            <div className="mt-1">
                                                                {story?.status ? (
                                                                    <span className='px-2 py-0.5 text-xs rounded-full bg-green-100 text-green-600 flex items-center w-max'>
                                                                        <LuDot size={16} /> Active
                                                                    </span>
                                                                ) : (
                                                                    <span className='px-2 py-0.5 text-xs rounded-full bg-red-100 text-red-600 flex items-center w-max'>
                                                                        <LuDot size={16} /> De Active
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <ActionButtons
                                                        item={story}
                                                        handleEdit={handleEdit}
                                                        handleDeleteStory={handleDeleteStory}
                                                        handleCheckboxChange={handleCheckboxChange}
                                                        size="small"
                                                    />
                                                </div>

                                                <div className="mt-3 grid grid-cols-2 gap-3">
                                                    <div className="flex flex-col items-center">
                                                        <span className="text-xs text-gray-500 mb-1">Thumbnail</span>
                                                        <img
                                                            src={story?.thembnal}
                                                            alt={'thembnal'}
                                                            className="w-16 h-16 object-cover rounded"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="mt-3 flex flex-wrap gap-2">
                                                    <div className="flex flex-col items-center bg-gray-50 rounded p-2 flex-1">
                                                        <span className="text-xs text-gray-500">Views</span>
                                                        <ClickView
                                                            label={formatView(story?.view)}
                                                            onClick={() => handleViewAnalitic(story?._id)}
                                                            size="small"
                                                        />
                                                    </div>
                                                    <div className="flex flex-col items-center bg-gray-50 rounded p-2 flex-1">
                                                        <span className="text-xs text-gray-500">Clicks</span>
                                                        <ClickView
                                                            label={formatView(story?.clickBtnCount)}
                                                            onClick={() => handleViewAnalitic(story?._id)}
                                                            size="small"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="mt-2 text-xs text-gray-500 text-center">
                                                    {formatDateTime(story?.date_time)}
                                                </div>
                                            </div>
                                        ))}
                                        {selectedUsers.length > 0 && (
                                            <div className="fixed bottom-4 right-4 z-10">
                                                <button
                                                    onClick={() => handleDeleteStory()}
                                                    className="bg-main-delete text-white p-3 rounded-full shadow-lg flex items-center justify-center"
                                                >
                                                    <MdDeleteSweep size={24} />
                                                    <span className="ml-1">{selectedUsers.length}</span>
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <NotFound />
                                )}
                            </div>

                            {/* Desktop Table View */}
                            <div className='hidden sm:block overflow-x-auto'>
                                <table className="w-full min-w-[800px]">
                                    <thead className="bg-main-th text-main-font uppercase">
                                        <tr>
                                            <th className='ps-6 py-3 text-left text-xs md:text-sm font-medium w-[5%]'>
                                                <div className="flex items-center gap-3">
                                                    <input
                                                        type='checkbox'
                                                        className="h-4 w-4 cursor-pointer"
                                                        onChange={(e) => setSelectedUsers(e.target.checked ? stories.map(story => story?._id) : [])}
                                                    />
                                                    {selectedUsers.length > 0 && (
                                                        <button
                                                            onClick={() => handleDeleteStory()}
                                                            className="text-main-delete"
                                                        >
                                                            <MdDeleteSweep size={20} />
                                                        </button>
                                                    )}
                                                </div>
                                            </th>
                                            <th className='px-3 py-3 text-left text-xs md:text-sm font-medium w-[5%]'>No</th>
                                            <th className='px-3 py-3 text-left text-xs md:text-sm font-medium w-[10%]'>Status</th>
                                            <th className='px-3 py-3 text-left text-xs md:text-sm font-medium w-[8%]'>View</th>
                                            <th className='px-3 py-3 text-left text-xs md:text-sm font-medium w-[8%]'>Click</th>
                                            <th className='px-3 py-3 text-left text-xs md:text-sm font-medium w-[10%]'>Thumbnail</th>
                                            <th className='px-3 py-3 text-left text-xs md:text-sm font-medium w-[15%]'>Date & Time</th>
                                            <th className='px-3 py-3 text-left text-xs md:text-sm font-medium w-[10%]'>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className='divide-y divide-gray-200'>
                                        {stories.length > 0 ? (
                                            stories.map((story, i) => (
                                                <tr key={story?._id} className="border-b hover:bg-main-thHover">
                                                    <td className="py-3 px-3 pl-6">
                                                        <input
                                                            type='checkbox'
                                                            className="cursor-pointer h-4 w-4"
                                                            checked={selectedUsers.includes(story?._id)}
                                                            onChange={() => handleselect(story?._id)}
                                                        />
                                                    </td>
                                                    <td className="py-3 px-3">{i + 1}</td>
                                                    <td className="py-3 px-3">
                                                        {story?.status ? (
                                                            <span className='px-3 py-1 text-xs rounded-full bg-green-100 text-green-600 flex items-center w-max'>
                                                                <LuDot size={16} /> Active
                                                            </span>
                                                        ) : (
                                                            <span className='px-3 py-1 text-xs rounded-full bg-red-100 text-red-600 flex items-center w-max'>
                                                                <LuDot size={16} /> De Active
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td className="py-3 px-3">
                                                        <ClickView
                                                            label={formatView(story?.view)}
                                                            onClick={() => handleViewAnalitic(story?._id)}
                                                        />
                                                    </td>
                                                    <td className="py-3 px-3">
                                                        <ClickView
                                                            label={formatView(story?.clickBtnCount)}
                                                            onClick={() => handleViewAnalitic(story?._id)}
                                                        />
                                                    </td>
                                                    <td className="py-3 px-3">
                                                        <img
                                                            src={story?.thembnal}
                                                            alt={'thembnal'}
                                                            className="w-16 h-16 object-cover rounded"
                                                        />
                                                    </td>
                                                    <td className="py-3 px-3 text-sm">
                                                        {formatDateTime(story?.date_time)}
                                                    </td>
                                                    <td className="py-3 px-3">
                                                        <ActionButtons
                                                            item={story}
                                                            handleEdit={handleEdit}
                                                            handleDeleteStory={handleDeleteStory}
                                                            handleCheckboxChange={handleCheckboxChange}
                                                        />
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={10}>
                                                    <div className="p-4">
                                                        <NotFound />
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );

};

export default StoryVideo;

const ActionButtons = ({ item, handleEdit, handleDeleteStory, handleCheckboxChange }) => {
    const [showActions, setShowActions] = useState(false);

    const handleButtonClick = () => {
        setShowActions(!showActions);
    };

    return (
        <div className='relative inline-block'>
            <ActionButton onClick={handleButtonClick} />
            {showActions && (
                <div className='absolute left-0 mt-2 bg-main-white border border-main-border rounded shadow-lg z-10'>

                    <div className='flex items-center justify-left ms-4 w-full my-2'>
                        <label className="cursor-pointer mt-1">
                            <input
                                type="checkbox"
                                checked={item?.status} // Reflect state in checkbox
                                onChange={(e) => handleCheckboxChange(item?._id, !item?.status)} // Handle checkbox toggle
                                className="sr-only peer"
                                name='storyvideo'
                            />
                            <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-red-300 dark:peer-focus:ring-red-800 dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-main-white after:border-main-border after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-red-600"></div>
                        </label>
                    </div>

                    <a
                        href={item?.video ? item?.video : item?.image}
                        target="_blank"
                        rel="noopener noreferrer"
                        className='flex items-center px-4 py-2 text-primary-purple hover:bg-purple-100 w-full text-left'
                    >
                        <FaRegCirclePlay size={20} className='me-2' /> Play
                    </a>

                    <button
                        className='flex items-center px-4 py-2 text-main-blue hover:bg-blue-100 w-full text-left'
                        onClick={() => handleEdit(item?._id)}
                    >
                        <FaEdit size={20} className='me-2' /> Edit
                    </button>
                    <button
                        className='flex items-center px-4 py-2 text-main-delete hover:bg-red-100 w-full text-left'
                        onClick={() => handleDeleteStory(item?._id)}
                    >
                        <FaTrash className='mr-2' /> Delete
                    </button>
                </div>
            )}
        </div>
    );
};